// The Day row's status chip: its word as Antonin's export names it (`docs/handoff-calendar-day.md` §4,
// `src/screens/practitioner/CalendarScreen.tsx` `enhanceDayList`). The chip itself is the grey neutral one for every
// status (Antonin, 1 Nov), so no tone is worked out here. Keyed on the API's own status code (`statusCode`), not the
// mapped `status`, which folds Fulfilled and any unknown code into "booked". An unknown code keeps the API's own word,
// as the export's `enhanceDayList` does.
// The chip's status circle (22 Oct, `enhanceDayList` `StatusGlyph`): the export's six statuses' shapes, checked in drawn
// 'half' and confirmed as booked ('empty'): Arrived, Checked in → half; In session → full; Completed → done; No show →
// alert; Confirmed, Booked, Cancelled and an unknown code → empty.
import type { GlyphKind } from '@/shared/ui/components/status-glyph-tokens';

export interface DayStatusChip {
  label: string;
  glyph: GlyphKind;
}

const KNOWN: Record<string, DayStatusChip> = {
  arrived: { label: 'Arrived', glyph: 'half' },
  checkedin: { label: 'Checked in', glyph: 'half' },
  inprogress: { label: 'In session', glyph: 'full' },
  insession: { label: 'In session', glyph: 'full' },
  confirmed: { label: 'Confirmed', glyph: 'empty' },
  fulfilled: { label: 'Completed', glyph: 'done' },
  completed: { label: 'Completed', glyph: 'done' },
  noshow: { label: 'No show', glyph: 'alert' },
  booked: { label: 'Booked', glyph: 'empty' },
  cancelled: { label: 'Cancelled', glyph: 'empty' },
  canceled: { label: 'Cancelled', glyph: 'empty' },
};

const key = (code: string | null | undefined) => (code ?? '').toLowerCase().replace(/[^a-z]/g, '');

export function dayStatusChip(row: { statusCode?: string | null; status?: string | null; statusDisplay?: string | null }): DayStatusChip {
  const code = key(row.statusCode) || key(row.status);
  const known = KNOWN[code];
  if (known) return known;
  const word = row.statusDisplay?.trim() || row.statusCode?.trim() || 'Booked';
  return { label: word, glyph: 'empty' };
}
